import { inject } from '@angular/core';
import type { HttpInterceptorFn } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import type { ApiErrorBody, NormalizedApiError } from '../models/api-response.model';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse)) {
        return throwError(() => error);
      }

      const body = error.error as Partial<ApiErrorBody> | null;
      const normalized: NormalizedApiError = {
        status: error.status,
        code: body?.error?.code ?? 'UNKNOWN_ERROR',
        message: body?.error?.message ?? 'Ocurrió un error inesperado.',
        details: body?.error?.details,
      };

      if (error.status === 402) {
        // Plan insuficiente (requirePlan) — la feature debe mostrar upsell hacia el plan que
        // sí incluye la feature, no un error genérico (CLAUDE.md §5).
        router.navigate(['/plan'], { queryParams: { upsell: normalized.code } });
      }

      if (error.status === 429) {
        // Rate limit (authLimiter/aiLimiter/globalLimiter, CLAUDE.md backend) — mensaje
        // claro en vez de genérico.
        normalized.message = 'Demasiados intentos, espera unos minutos.';
      }

      return throwError(() => normalized);
    }),
  );
};
